import * as S from './style'

export type Props = {
  title: string
  background: 'black' | 'gray'
  children: JSX.Element
}
const Section = ({ title, background, children }: Props) => {
  return (
    <S.Container background={background}>
      <div className="container">
        <S.Title>{title}</S.Title>
        {children}
      </div>
    </S.Container>
  )
}
export default Section
